
import React from "react";

declare global {
    interface UiSettings {}
}
export interface SetSetting {
    <T extends keyof UiSettings>(key: T, val: UiSettings[T]) : void;
}


const settingsContext = React.createContext<{
    setSetting: SetSetting;
    settings: UiSettings | null;
    settingsLoaded: boolean;
}>({
    setSetting: () => {},
    settings: null,
    settingsLoaded: false,
});



export const SettingsProvider = ({ defaultSettings,  children }: { defaultSettings : UiSettings, children: React.ReactNode }) => {
    const [settingsLoaded, setSettingsLoaded] = React.useState(false);
    const [settings, setSettings] = React.useState(defaultSettings);

    const setSetting : SetSetting = (key, val) => {
        window.localStorage.setItem(
            "settings",
            JSON.stringify({
                [key]: val,
            })
        );
        setSettings({
            ...settings,
            [key]: val,
        });
    };

    React.useEffect(() => {
        const localSettings = window.localStorage.getItem("settings");
        localSettings && setSettings({ ...JSON.parse(localSettings) });
        setSettingsLoaded(true);
    }, []);

    return (
        <settingsContext.Provider value={{ setSetting, settings, settingsLoaded }}>
            {children}
        </settingsContext.Provider>
    );
};

export const useSettings = () => React.useContext(settingsContext);
